import { sha256 } from '@noble/hashes/sha256';
import { bytesToHex } from '@noble/hashes/utils';

/**
 * Google transaction IDs must fit in 64 characters. Preserve existing valid IDs and
 * hash longer IDs as lowercase SHA-256 hex of their UTF-8 bytes, without truncating them.
 * Client and server purchase events must use this helper with the same original ID
 * (e.g. the Checkout Session ID), so retries and both delivery paths deduplicate.
 */
export function normalizeAnalyticsTransactionId(transactionId: string): string {
  return transactionId.length <= 64 ? transactionId : bytesToHex(sha256(transactionId));
}

/**
 * Lowercase hex SHA-256, the format Meta, Google and TikTok expect for hashed user data. The browser
 * pixels and the server conversions share it, so the platforms can join both on the same person.
 */
export function hashAnalyticsUserData(value: string): string {
  return bytesToHex(sha256(value));
}

export function hashAnalyticsEmail(email: string): string {
  return hashAnalyticsUserData(email.trim().toLowerCase());
}
